import * as adl from '@pollfish/pf-advanced-logic';
import {
  CarryForwardService,
  VisibilityService,
  shuffleArray,
  getAnswersShuffleType,
  getScorepointShuffleType,
  getGenericShuffleType,
  getShuffledAndCarriedForwardAnswers,
  base64,
  getDecodedText,
  enrichMatrixRows,
  isMatrix,
  isMatrixTypeLikert,
  isMatrixOpenEndedFamily,
  isNodeSupportVisibility,
  LoopAndMergeService,
  GroupNode,
} from '@pollfish/pf-library-of-power';

export const questionnaireLogicService = adl.QuestionnaireLogicService.withKnowledge();
export const questionnairePathTraversal = new adl.QuestionnairePathTraversal(
  questionnaireLogicService,
);

export const {
  KnowledgeKeys,
  OutcomeType,
  FinalNode,
  ActionVisibilityValueType,
  Matcher,
  RespondentKnowledge,
  FinalGroupNode,
} = adl;

export const KnowledgeKeysByOutcomeType = {
  [adl.OutcomeType.Variable]: adl.KnowledgeKeys.Variables,
  [adl.OutcomeType.Answer]: adl.KnowledgeKeys.Visibility,
};

export const carryForwardService = new CarryForwardService();
export const loopAndMergeService = new LoopAndMergeService(carryForwardService);
export {
  VisibilityService,
  shuffleArray,
  getAnswersShuffleType,
  getScorepointShuffleType,
  getGenericShuffleType,
  getShuffledAndCarriedForwardAnswers,
  base64,
  getDecodedText,
  isMatrix,
  isMatrixTypeLikert,
  isMatrixOpenEndedFamily,
  enrichMatrixRows,
  isNodeSupportVisibility,
  GroupNode,
};
